import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {EffectsModule} from '@ngrx/effects';
import {CartAdapter} from '@spartacus/cart/base/core';
import {ConfigModule, I18nModule, UrlModule} from '@spartacus/core';

import {BundleProvidedByModule} from '../checkout/bundle-provided-by/bundle-provided-by.module';
import {TermsAndConditionsModule} from '../checkout/checkout-terms-conditions/terms-and-conditions.module';
import {DynamicAuthGuard} from '../checkout/guards/dynamic-auth.guard';
import {UserAccountFacadeUpdateGuard} from '../checkout/guards/user-account-facade-update.guard';
import {DcpOrderConfirmationModule} from '../checkout/order-confirmation/order-confirmation.module';
import {OrderTableModule} from '../checkout/order-table/order-table.module';

import {ConfiguratorModule} from '../product/configurator/configurator.module';

import {SummaryModule} from '../shared/summary/summary.module';
import {CartComponent} from './cart.component';
import {CartEditModule} from './edit-cart/cart-edit.module';
import {EmptyCartSetFocusModule} from './empty-cart-set-focus/empty-cart-set-focus.module';
import {DcpCartAdapter} from './occ/dcp-cart.adapter';
import {OutdatedCartMessageComponent} from './outdated-cart-message/outdated-cart-message.component';
import {PoNumberEffects} from './store/effects/po-number.effect';
import {StoreModule} from '@ngrx/store';
import {CartVoucherGlobalMessageEffect} from '@app/cart/store/effects/cart-voucher-global-message.effect';
import {configurationFeatureKey, configurationReducer, LoadingPageComponent} from '@dcp/configurator';

const FALLBACK_CANCELLATION_URL = 'https://store.sap.com/dcp/en';

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CartComponent: {
          component: CartComponent,
          guards: [DynamicAuthGuard, UserAccountFacadeUpdateGuard],
        },
      },
    }),
    StoreModule.forFeature(configurationFeatureKey, configurationReducer, {
      initialState: {cancellationUrl: FALLBACK_CANCELLATION_URL},
    }),
    EffectsModule.forFeature([PoNumberEffects, CartVoucherGlobalMessageEffect]),
    I18nModule,
    CartEditModule,
    UrlModule,
    DcpOrderConfirmationModule,
    SummaryModule,
    ConfiguratorModule,
    EmptyCartSetFocusModule,
    BundleProvidedByModule,
    OrderTableModule,
    TermsAndConditionsModule,
    LoadingPageComponent,
    CartComponent,
    OutdatedCartMessageComponent,
  ],
  exports: [CartComponent, OutdatedCartMessageComponent],
  providers: [{provide: CartAdapter, useClass: DcpCartAdapter}],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CartModule {}
